import { render } from "./PrintableDataTable.vue?vue&type=template&id=f91ab416&ts=true"
import script from "./PrintableDataTable.vue?vue&type=script&lang=ts"
export * from "./PrintableDataTable.vue?vue&type=script&lang=ts"

import "./PrintableDataTable.vue?vue&type=style&index=0&id=f91ab416&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__